import { Core } from '@unseenco/taxi'

import DefaultRenderer from './renderers/default'
import DefaultTransition from './transitions/default'

// Page transitions
const taxi = new Core({
	links: 'a:not([target]):not([href^=\\#]):not([data-taxi-ignore]):not([data-dropdown]):not(.venobox):not(.modal-toggle):not([data-scrollto]):not([data-fancybox])',
	renderers: {
		default: DefaultRenderer,
	},
	transitions: {
		default: DefaultTransition,
	},
})
